export const dominantNuanceLabels: Record<0 | 1, string> = {
  0: "Clair",
  1: "Foncé",
};

export const dominantColorLabels: Record<
  0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9,
  string
> = {
  0: "Noir",
  1: "Marron",
  2: "Rouge",
  3: "Orange",
  4: "Jaune",
  5: "Vert",
  6: "Bleu",
  7: "Beige",
  8: "Gris",
  9: "Blanc",
};
